import React from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import './App.css';
import Navbar from './Components/NavBar/navBar'
import Footer from './Components/Footer/footer'
import Home from './Pages/home'
import Contact from './Pages/contact'
import About from './Pages/about'
import TreksMain from './Pages/treksMain'
import CulturalMain from './Pages/CulturalMain'
import ExpeditionsMain from './Pages/EductionalMain'
import ExpeditionsCategories from './Pages/ExpeditionsCategories'
import WhyChooseUs from './Pages/WhyChooseUs'
import NotFound from './Pages/NotFound';

import Login from './Components/Auth/Login';
import Signup from './Components/Auth/Signup';

// ===== BLOGS =====
import BlogsList from "./Components/Blogs/BlogsList/BlogList";
import K2ViewPoints from "./Components/Blogs/BlogsDetails/K2ViewPoints/K2ViewPoints";
import BaltistanValley from './Components/Blogs/BlogsDetails/BaltistanValley/BaltistanValley';

import WhatsAppButton from './Components/whatsApp/WhatsAppButton';
import TripDetailsPage from './Components/Tours/CulturalTours/details/DesertSafariAndJeepTours/Main/TripDetailsPage';
import AdminPanel from './Pages/Admin/admin';
import Trips from './Pages/Admin/trips';
import NewTripForm from './Pages/Admin/newTripForm';
import Dashboard from './Pages/Admin/dashboard';
import EditTrip from './Pages/Admin/editTrip';
import Categories from './Pages/Admin/categories';
import NewCategoryForm from './Pages/Admin/newCategoryForm';
import EditCategory from './Pages/Admin/editCategory';
import Bookings from './Pages/Admin/bookings';
import MyBookings from './Pages/User/booking';
import Cards from './Components/Treks/challengingTreks/ChallengingTreksCards/ChallengingCards';
import UserPanel from './Pages/User/user.jsx';
import Profile from './Pages/User/profile.jsx';
import Reviews from './Pages/Admin/reviews.jsx';

const App = () => {
  return (
    <Router>

      <Navbar />
      <Routes>
        {/* ===== HOME PAGE ===== */}
        <Route path='/' element={
          <>
            <Home />
            <TreksMain />
            <CulturalMain />
            <ExpeditionsMain />
            <ExpeditionsCategories />
            <WhyChooseUs />
            {/* <Footer /> */}
          </>
        } />

        {/* ===== STATIC PAGES ===== */}
        <Route path='/contact' element={<Contact />} />
        <Route path='/about' element={<About />} />

        {/* ===== TOURS ===== */}
        <Route path='/category/:category' element={<Cards />} />


        {/* ===== BLOGS ===== */}
        <Route path="/blogs" element={<BlogsList />} />
        <Route path="/blogs/k2viewpoints" element={<K2ViewPoints />} />
        <Route path="/blogs/baltistanvalley" element={<BaltistanValley />} />

        {/*login and sign up  */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />

        <Route path='/admin' element={
          <AdminPanel>
            <Dashboard />
          </AdminPanel>
        } />
        <Route path='/admin/profile' element={
          <AdminPanel>
            <Profile />
          </AdminPanel>
        } />
        <Route path='/admin/trips' element={
          <AdminPanel>
            <Trips />
          </AdminPanel>
        } />
        <Route path='/admin/trips/new' element={
          <AdminPanel>
            <NewTripForm />
          </AdminPanel>
        } />
        <Route path='/admin/trips/edit/:tripId' element={
          <AdminPanel>
            <EditTrip />
          </AdminPanel>
        } />

        <Route path='/admin/categories' element={
          <AdminPanel>
            <Categories />
          </AdminPanel>
        } />
        <Route path='/admin/categories/new' element={
          <AdminPanel>
            <NewCategoryForm />
          </AdminPanel>
        } />
        <Route path='/admin/categories/edit/:categoryId' element={
          <AdminPanel>
            <EditCategory />
          </AdminPanel>
        } />
        <Route path='/admin/bookings' element={
          <AdminPanel>
            <Bookings />
          </AdminPanel>
        } />
        <Route path='/admin/reviews' element={
          <AdminPanel>
            <Reviews />
          </AdminPanel>
        } />
        <Route path='/dashboard' element={
          <UserPanel>
            <div>Welcome to your dashboard</div>
          </UserPanel>
        } />
        <Route path='/my-bookings' element={
          <UserPanel>
            <MyBookings />
          </UserPanel>
        } />
        <Route path='/my-profile' element={
          <UserPanel>
            <Profile />
          </UserPanel>
        } />
        <Route path="*" element={<NotFound />} />

        {/* ✅ Common Trip Detail Route */}
        <Route path='/:slug' element={<TripDetailsPage />} />
      </Routes>
      <Footer />
      <WhatsAppButton />
    </Router>
  )
}

export default App;
